import React from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import { ArrowRight, Robot, Eye, Scales, TrendUp } from "@phosphor-icons/react";
import Seo from "@/components/Seo";

const pressures = [
  { icon: Robot, text: "AI is changing how people work faster than people can adapt to it." },
  { icon: Eye, text: "Attention is being competed for constantly." },
  { icon: Scales, text: "The line between work and not-working has disappeared." },
  { icon: TrendUp, text: "The cognitive load on your workforce is going up, not down." },
];

export default function Corporate() {
  return (
    <Page>
      <Seo title="For Corporates · Workplace Wellbeing" description="Employee wellness audits, team workshops and organisational wellbeing programmes for modern workplaces." />
      <section className="md-section md-page-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-4">Corporate Wellness</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif max-w-4xl">
            Most organisations are already dealing with the effects of <em>cognitive overload</em>.
            <br className="hidden md:block" /> They just don&apos;t have the language for it yet.
          </h1>
          <p className="text-base mt-6 max-w-3xl mx-auto" data-testid="corporate-hero-sub">
            Distracted teams, short fuses in meetings, good people who can&apos;t switch off, this isn&apos;t a motivation problem or a management problem. It&apos;s what happens when the brain is operating in an environment it wasn&apos;t built for, and nobody has explained that to anyone.
          </p>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <p className="text-lg font-serif" data-testid="corporate-intro">
              We work with HR and leadership teams who want to get ahead of what&apos;s coming, because the next five years are going to be harder.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-testid="corporate-pressures">
            {pressures.map((p) => (
              <div key={p.text} className="md-card flex items-start gap-4">
                <div className="how-glass-ico shrink-0" style={{ background: "var(--md-bg-alt)", border: "1px solid var(--md-border)" }}>
                  <p.icon size={24} weight="duotone" style={{ color: "var(--md-primary)" }} />
                </div>
                <p className="text-sm mt-2" style={{ color: "var(--md-text-soft)" }}>{p.text}</p>
              </div>
            ))}
          </div>

          <div className="max-w-3xl mx-auto text-center mt-14">
            <p className="text-base" style={{ color: "var(--md-text-soft)" }} data-testid="corporate-neuro">
              Neuroscience is the tool we use to remove blame, create shared understanding, and give people a practical framework for how to actually function well in this environment.
            </p>
            <div className="mt-10">
              <Link to="/contact?source=corporate-enquire" className="btn-primary" data-testid="corporate-enquire">
                Enquire about a partnership <ArrowRight size={14} weight="bold" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
}
